// Services principaux — pages SEO money
import {
  Trees, Scissors, Axe, Leaf, Sparkles, Brush, Building2, Mountain, Hammer, Flower2, Wrench,
} from "lucide-react";

export const SERVICES = [
  {
    slug: "paysagiste-caen",
    title: "Paysagiste à Caen",
    h1: "Paysagiste à Caen — Création & aménagement de jardins haut de gamme",
    short: "Création de jardins sur mesure, aménagement paysager et conseil personnalisé dans le Calvados.",
    icon: "Leaf",
    image: "https://images.unsplash.com/photo-1576897955702-24ad19680db3?auto=format&fit=crop&w=1600&q=80",
    metaTitle: "Paysagiste Caen | Les Jardiniers Normands – Aménagement Jardin Calvados",
    metaDescription: "Paysagiste à Caen ⭐ Création de jardin, aménagement extérieur, terrasse, allée, plantation. Devis gratuit dans tout le Calvados. ☎ 07 80 04 43 90",
    keywords: ["paysagiste caen", "aménagement jardin caen", "paysagiste calvados", "création jardin caen"],
    brand: "jardiniers",
  },
  {
    slug: "jardinier-caen",
    title: "Jardinier à Caen",
    h1: "Jardinier à Caen — Entretien jardin & espaces verts toute l'année",
    short: "Entretien régulier de jardins, tonte, débroussaillage, désherbage et soin des massifs.",
    icon: "Flower2",
    image: "https://images.pexels.com/photos/3280078/pexels-photo-3280078.jpeg?auto=compress&cs=tinysrgb&w=1600",
    metaTitle: "Jardinier Caen | Entretien Jardin Calvados – Les Jardiniers Normands",
    metaDescription: "Jardinier professionnel à Caen ⭐ Entretien jardin, tonte, taille, désherbage. Contrat annuel ou ponctuel. Devis gratuit ☎ 07 80 04 43 90.",
    keywords: ["jardinier caen", "entretien jardin caen", "tonte pelouse caen", "jardinier calvados"],
    brand: "jardiniers",
  },
  {
    slug: "elagage-caen",
    title: "Élagage à Caen",
    h1: "Élagage à Caen — Élagueur grimpeur certifié Calvados",
    short: "Élagage de précision, taille douce, taille raisonnée par grimpeurs qualifiés et assurés.",
    icon: "Scissors",
    image: "https://images.unsplash.com/photo-1762903938137-49b0a145e241?auto=format&fit=crop&w=1600&q=80",
    metaTitle: "Élagage Caen | Élagueur Grimpeur Certifié – Pro Élagage 14",
    metaDescription: "Élagueur à Caen ⭐ Élagage, taille raisonnée, sécurisation d'arbres. Grimpeurs certifiés, assurés. Intervention rapide Calvados ☎ 07 80 04 43 90.",
    keywords: ["élagage caen", "élagueur caen", "taille arbre caen", "élagueur calvados"],
    brand: "proElagage",
  },
  {
    slug: "abattage-arbre-caen",
    title: "Abattage d'arbre à Caen",
    h1: "Abattage d'arbre à Caen — Intervention sécurisée par professionnels",
    short: "Abattage classique, abattage par démontage en milieu contraint, évacuation complète.",
    icon: "Axe",
    image: "https://images.unsplash.com/photo-1474742509976-ddec6b387356?auto=format&fit=crop&w=1600&q=80",
    metaTitle: "Abattage Arbre Caen | Pro Élagage 14 – Démontage Sécurisé Calvados",
    metaDescription: "Abattage arbre à Caen ⭐ Démontage, rétention, évacuation. Travail sécurisé par grimpeurs qualifiés. Devis gratuit Calvados ☎ 07 80 04 43 90.",
    keywords: ["abattage arbre caen", "abattage caen", "démontage arbre caen", "abattage calvados"],
    brand: "proElagage",
  },
  {
    slug: "dessouchage-caen",
    title: "Dessouchage à Caen",
    h1: "Dessouchage à Caen — Rognage de souche par professionnels",
    short: "Suppression de souches au rogneuse mécanique, sans dégâts pour votre terrain.",
    icon: "Hammer",
    image: "https://images.unsplash.com/photo-1474742509976-ddec6b387356?auto=format&fit=crop&w=1600&q=80",
    metaTitle: "Dessouchage Caen | Rognage Souche – Pro Élagage 14 Calvados",
    metaDescription: "Dessouchage à Caen ⭐ Rognage souche, extraction mécanique. Terrain prêt à replanter. Devis gratuit dans tout le Calvados ☎ 07 80 04 43 90.",
    keywords: ["dessouchage caen", "rognage souche caen", "enlèvement souche caen"],
    brand: "proElagage",
  },
  {
    slug: "taille-haie-caen",
    title: "Taille de haie à Caen",
    h1: "Taille de haie à Caen — Entretien et taille de précision",
    short: "Taille d'entretien, taille de formation, broyage des déchets verts inclus.",
    icon: "Scissors",
    image: "https://images.unsplash.com/photo-1576897955702-24ad19680db3?auto=format&fit=crop&w=1600&q=80",
    metaTitle: "Taille de Haie Caen | Entretien Haies Calvados – Les Jardiniers Normands",
    metaDescription: "Taille de haie à Caen ⭐ Entretien, taille de formation, évacuation. Devis gratuit Calvados ☎ 07 80 04 43 90.",
    keywords: ["taille haie caen", "tailleur haie caen", "entretien haie calvados"],
    brand: "jardiniers",
  },
  {
    slug: "entretien-jardin-caen",
    title: "Entretien jardin à Caen",
    h1: "Entretien de jardin à Caen — Contrat annuel ou prestation ponctuelle",
    short: "Tonte, désherbage, soin des massifs, ramassage de feuilles : un jardin impeccable toute l'année.",
    icon: "Leaf",
    image: "https://images.pexels.com/photos/3280078/pexels-photo-3280078.jpeg?auto=compress&cs=tinysrgb&w=1600",
    metaTitle: "Entretien Jardin Caen | Contrat Annuel – Les Jardiniers Normands",
    metaDescription: "Entretien jardin à Caen ⭐ Contrat annuel, prestations ponctuelles. Crédit d'impôt 50%. Devis gratuit Calvados ☎ 07 80 04 43 90.",
    keywords: ["entretien jardin caen", "contrat entretien jardin", "entretien espaces verts calvados"],
    brand: "jardiniers",
  },
  {
    slug: "entretien-exterieur-caen",
    title: "Entretien extérieur à Caen",
    h1: "Entretien extérieur à Caen — Tous services pour votre extérieur",
    short: "Solution complète : jardin, élagage, taille de haie, allée, terrasse — un seul interlocuteur de confiance.",
    icon: "Mountain",
    image: "https://images.unsplash.com/photo-1597201278257-3687be27d954?auto=format&fit=crop&w=1600&q=80",
    metaTitle: "Entretien Extérieur Caen | Service Complet – Les Jardiniers Normands",
    metaDescription: "Entretien extérieur à Caen ⭐ Jardin, toiture, façade, allée. Service complet Calvados. Devis gratuit ☎ 07 80 04 43 90.",
    keywords: ["entretien extérieur caen", "entretien maison extérieur", "service extérieur calvados"],
    brand: "jardiniers",
  },
];

export const ICONS = { Trees, Scissors, Axe, Leaf, Sparkles, Brush, Building2, Mountain, Hammer, Flower2, Wrench };

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
